var map = {
	"./Accounting.svg": "84b3",
	"./B.Stat.svg": "f965",
	"./Banking.svg": "63d8",
	"./Biology.svg": "f64a",
	"./BiologyEx.svg": "7e45",
	"./Business Mathematics.svg": "6d9a",
	"./Chemistry.svg": "816c",
	"./ChemistryEx.svg": "2734",
	"./Com.Geo.svg": "a9a9",
	"./Computer Networks.svg": "70f0",
	"./Computer Science.svg": "dc26",
	"./English.svg": "fa30",
	"./EnglishEx.svg": "d237",
	"./F.Cs.svg": "fbf2",
	"./F.Sc (Engineering).svg": "5aa3",
	"./F.Sc (Medical).svg": "d874",
	"./FSc (Engineering).svg": "454a",
	"./FSc (Medical).svg": "5251",
	"./I.COM.svg": "c836",
	"./ICS.svg": "b814",
	"./ICT.svg": "65ea",
	"./Icom.Computer Studies.svg": "23cb",
	"./Intermediate Of Computer Science.svg": "e724",
	"./Introduction to MS-Office.svg": "0bda",
	"./Introduction to Programming.svg": "2901",
	"./Islamic Studies.svg": "00c3",
	"./Islamic StudiesEx.svg": "ca15",
	"./Mathematics.svg": "5ba0",
	"./MathematicsEx.svg": "a4f7",
	"./NoMatch.svg": "014c",
	"./NoimageIcon.svg": "c6f2",
	"./Operating System.svg": "f494",
	"./Pakistan Studies.svg": "a0ad",
	"./Pakistan StudiesEx.svg": "c723",
	"./Physics.svg": "713b",
	"./PhysicsEx.svg": "2479",
	"./Practical.svg": "e15f",
	"./Principle of Commerce.svg": "2718",
	"./Principle of Economics.svg": "d08a",
	"./Statistics.svg": "740b",
	"./Urdu.svg": "73a4",
	"./UrduEx.svg": "5a10",
	"./ai.svg": "628e",
	"./cri.svg": "dd4f",
	"./e.svg": "bed8",
	"./fr.svg": "0c75",
	"./noicon.svg": "a09f",
	"./outher.svg": "3661",
	"./shopify.svg": "c7eb",
	"./wb.svg": "109a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a0bd";